import {gsap} from "gsap";
import {SlotGame} from "@nolimit/slot-game/bin/SlotGame";
import {NineToFiveGameAssets} from "../NineToFiveGameAssets";

export class BasedCountUp extends PIXI.Container {
    private winAmount:number;
    private winText:PIXI.BitmapText
    private fadeDuration:number;

    constructor() {
        super();
        this.fadeDuration = 0.1
        this.winAmount = 0;
        this.winText = new PIXI.BitmapText(`${this.winAmount}`, {
            fontName : NineToFiveGameAssets.BITMAP_FONT_WIN_COUNT_UP,
            fontSize : 60,
        });
        this.winText.alpha = 0;
        // why do I need to cast this?
        (<PIXI.Point>this.winText.anchor).set(0.5, 0.5);
        this.addChild(this.winText);
    }

    private formatWinAmountText():void {
        this.winText.scale.set(1,1);
        this.winText.text = SlotGame.apiPlugin.currency.formatValue(this.winAmount);
        if (this.winText.width > 700) {
            const newScale = 700 / this.winText.width;
            this.winText.scale.set(newScale, newScale);
        }
    }

    public countUp(to:number, from:number = 0, duration:number = 1) {
        return gsap.timeline({onUpdate: () => {this.formatWinAmountText()}})
            .add(() => {
                this.winAmount = from;
                this.formatWinAmountText();
            })
            .add(gsap.to(this.winText, {alpha: 1, duration:this.fadeDuration}))
            .add(gsap.to(this, {duration: duration, winAmount: to, ease: "none"}), '<');
    }

    public countUpNoFade(to:number, from:number = 0, duration:number = 1) {
        return gsap.timeline({onUpdate: () => {this.formatWinAmountText()}})
            .add(() => {
                this.winText.alpha = 1;
                this.winAmount = from;
                this.formatWinAmountText();
            })
            .add(gsap.to(this, {duration: duration, winAmount: to, ease: "none"}), '<');
    }

    public countUpInstant(to:number, from:number = 0) {
        return gsap.timeline({onUpdate: () => {this.formatWinAmountText()}})
            .add(() => {
                this.winAmount = to;
                this.formatWinAmountText();
            })
            .add(gsap.to(this.winText, {alpha: 1, duration: this.fadeDuration}))
    }

    public showNoFade(amount:number):gsap.core.Timeline {
        return gsap.timeline().add(() => {
            this.winAmount = amount;
            this.formatWinAmountText();
            this.winText.alpha = 1;
        });
    }

    public show(amount:number) {
        return gsap.timeline()
            .add(() => {
                this.winAmount = amount;
                this.formatWinAmountText();
            })
            .add(gsap.to(this.winText, {alpha: 1, duration:this.fadeDuration}));
    }

    public hide() {
        return gsap.timeline().add(gsap.to(this.winText, {alpha: 0, duration:this.fadeDuration}));
    }
}
